<template>
  <ListeReferentiel
    ref="liste"
    titre="Lits"
    icone="bi-hospital"
    ressource="lits"
    tri-defaut="li.numero"
    :options-tri="{ Numéro: 'li.numero', Chambre: 'ch.numero', Statut: 'li.isEnabled', 'Date de création': 'li.createdAt' }"
    placeholder="Numéro du lit ou de la chambre…"
    unite="lit(s)"
    vide="Aucun lit enregistré."
    :colonnes="7"
    :filtres="{ chambre, etat }"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_LIT')"
    libelle-creer="Nouveau lit"
    @creer="creation"
  >
    <template #filtres>
      <div class="col-6 col-md-2">
        <label class="form-label fw-semibold small mb-1">Chambre</label>
        <select v-model="chambre" class="form-select form-select-clinique">
          <option value="">Toutes</option>
          <option v-for="c in chambres" :key="c.id" :value="c.id">{{ c.numero }}</option>
        </select>
      </div>
      <div class="col-6 col-md-2">
        <label class="form-label fw-semibold small mb-1">Occupation</label>
        <select v-model="etat" class="form-select form-select-clinique">
          <option value="">Tous</option>
          <option value="libre">Libres</option>
          <option value="Occupé">Occupés</option>
        </select>
      </div>
    </template>
    <template #entete>
      <th>Numéro</th>
      <th>Chambre</th>
      <th class="d-none d-md-table-cell">Type de chambre</th>
      <th>Occupation</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: lit }">
      <td>{{ lit.numero }}</td>
      <td>{{ lit.chambre?.numero || '—' }}</td>
      <td class="d-none d-md-table-cell">{{ lit.chambre?.type?.nom || '—' }}</td>
      <td>
        <span :class="['badge', estLibre(lit) ? 'bg-success' : 'bg-danger']">{{ estLibre(lit) ? 'Libre' : 'Occupé' }}</span>
      </td>
      <td>
        <span :class="['badge', lit.isEnabled ? 'bg-success' : 'bg-secondary']">{{ lit.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_LIT', 'CONFIG_SUPPRESSION_LIT'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_LIT')"><a class="dropdown-item" href="#" @click.prevent="modifier(lit.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_LIT')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(lit)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api from '@/api';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeLit',
  components: { ListeReferentiel },
  data() {
    return { chambre: '', etat: '', chambres: [] };
  },
  async created() {
    try {
      const res = await api.getItems('chambres', { orderBy: 'ch.numero', sortOrder: 'asc' });
      this.chambres = res.data?.data || [];
    } catch {
      this.chambres = [];
    }
  },
  methods: {
    estLibre(lit) {
      return String(lit.etat || 'libre').toLowerCase() === 'libre';
    },
    creation() {
      this.$router.push({ name: 'create_lit' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_lit', params: { id } });
    },
    supprimer(lit) {
      this.$refs.liste.supprimer({
        id: lit.id,
        titre: 'Supprimer le lit',
        message: `Supprimer le lit ${lit.numero}${lit.chambre?.numero ? ' (chambre ' + lit.chambre.numero + ')' : ''} ?`,
        succes: 'Lit supprimé.',
      });
    },
  },
};
</script>
